const ROUTES={
    socials:{
        twitter: "https://twitter.com/tech_phantoms",
        github: "https://github.com/Tech-Phantoms",
        discord: "https://discord.apihacks.co",
        opencollective: "https://opencollective.com/techphantoms",
        apihacks: "https://apihacks.co",
    }
}
export default ROUTES;